"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentRendererWithQuery = void 0;

var _react = _interopRequireWildcard(require("react"));

var _client = require("@apollo/client");

var _context = require("../../context");

var _ComponentRenderer = require("../ComponentRenderer");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ComponentRendererWithQuery = function ComponentRendererWithQuery(_ref) {
  var className = _ref.className,
      componentMapOverride = _ref.componentMap,
      context = _ref.context,
      queryMapOverride = _ref.queryMap,
      type = _ref.type,
      variables = _ref.variables;

  try {
    var _useContext = (0, _react.useContext)(_context.ContentfulContext),
        componentMapDefault = _useContext.componentMap,
        queryMapDefault = _useContext.queryMap;

    var query = (queryMapOverride || queryMapDefault)[type]();

    var _useQuery = (0, _client.useQuery)(query, {
      variables: variables,
      context: context
    }),
        data = _useQuery.data;

    if (!data) return null;
    var _key = Object.keys(data)[0];
    if (!_key) return null;
    var dataToParse = _key.indexOf('Collection') >= 0 ? data[_key].items[0] : data[_key];
    return /*#__PURE__*/_react.default.createElement(_ComponentRenderer.ComponentRenderer, {
      className: className,
      data: dataToParse,
      componentMap: componentMapOverride || componentMapDefault
    });
  } catch (e) {
    console.log('error', e);
    return null;
  }
};

exports.ComponentRendererWithQuery = ComponentRendererWithQuery;